function assinaturaClube() {
  return {
    etapa: 'planos', // planos -> sabores (sabor + quantidade, já vai pro carrinho em tempo real)
    planoAssinaturaSelecionado: '30', // '30' | '90' | '180'
    saboresSelecionados: {},
    produtosSabores: [],
    precoBase: 0,
    sachesPorCaixa: 12,
    planoDescontos: {}, // { '30': 20, '90': 22, '180': 25 } — desconto fixo por plano de assinatura
    carrinho: { item_count: 0, total_price: 0 },
    atualizando: false,

    get totalSelecionado() {
      return Object.values(this.saboresSelecionados).reduce((a, b) => a + b, 0);
    },

    precoOriginal() {
      return this.precoBase.toFixed(2);
    },

    descontoClubeAtual() {
      return this.planoDescontos[this.planoAssinaturaSelecionado] || 0;
    },

    precoAtual() {
      return this.precoBase * (1 - this.descontoClubeAtual() / 100);
    },

    async init() {
      try {
        this.produtosSabores = (window.produtosSabores || []).map(p => ({
          ...p,
          available: p.available !== false && p.available !== 'false',
          pre_venda: p.pre_venda === true
        }));
      } catch (err) {
        console.error('Erro ao carregar sabores:', err);
      }

      const wrapper = document.querySelector('[data-preco]');
      this.precoBase = parseFloat(wrapper?.dataset?.preco || 0);
      this.sachesPorCaixa = parseInt(wrapper?.dataset?.sachesPorCaixa || 12, 10);
      this.planoDescontos = window.planoDescontosClube || { '30': 20, '90': 22, '180': 25 };

      await this.atualizarResumoCarrinho();
    },

    escolherPlano(plano) {
      this.planoAssinaturaSelecionado = plano;
      this.etapa = 'sabores';
    },

    algumEmPreVenda() {
      return Object.entries(this.saboresSelecionados).some(([id, qtd]) => {
        const produto = this.produtosSabores.find(p => p.variant_id == id);
        return produto && produto.pre_venda === true && qtd > 0;
      });
    },

    async atualizarResumoCarrinho() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        this.carrinho = { item_count: cart.item_count, total_price: cart.total_price };
        window.dispatchEvent(new Event('cart-change'));
      } catch (err) {
        console.error('Erro ao atualizar carrinho:', err);
      }
    },

    async incluirSabor(produto) {
      if (this.atualizando) return;
      this.atualizando = true;
      const jaTinha = this.saboresSelecionados[produto.variant_id] > 0;
      const novaQtd = (this.saboresSelecionados[produto.variant_id] || 0) + 1;

      try {
        if (!jaTinha) {
          const item = { id: produto.variant_id, quantity: 1 };
          const sellingPlanId = produto.selling_plans?.[this.planoAssinaturaSelecionado];
          if (sellingPlanId) item.selling_plan = sellingPlanId;
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (!res.ok) throw new Error('add-failed');
        } else {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(produto.variant_id), quantity: novaQtd })
          });
          if (!res.ok) throw new Error('change-failed');
        }

        this.saboresSelecionados[produto.variant_id] = novaQtd;
        await this.atualizarResumoCarrinho();
      } catch (err) {
        console.error('Erro ao adicionar sabor ao carrinho:', err);
      } finally {
        this.atualizando = false;
      }
    },

    async removerSabor(produto) {
      if (this.atualizando) return;
      const atual = this.saboresSelecionados[produto.variant_id] || 0;
      if (atual <= 0) return;
      this.atualizando = true;
      const novaQtd = atual - 1;

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(produto.variant_id), quantity: novaQtd })
        });
        if (!res.ok) throw new Error('change-failed');

        this.saboresSelecionados[produto.variant_id] = novaQtd;
        await this.atualizarResumoCarrinho();
      } catch (err) {
        console.error('Erro ao remover sabor do carrinho:', err);
      } finally {
        this.atualizando = false;
      }
    }
  };
}
